module.exports = __webpack_public_path__ + "pc/img/ico-arrow-up.8f5bbfcf.svg";